import { usePaymentInfo } from '@/hooks/api/2280_workspace_payment_info';
import { useWorkspacePayments } from '@/hooks/api/2330_workspace_payments';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import moment from 'moment';
import { Link } from 'react-router-dom';

export const PlanAndBilling = () => {
  const { _w_, me } = useCurrentWorkspace();

  return (
    <div className="card mb-4" id="basic-info">
      <div className="card-header d-flex align-items-center">
        <div className="col-md-8">
          <h5 className="mb-0">スペースプラン設定</h5>
        </div>
        {me!.admin && (
          <div className="col-md-4 d-flex justify-content-end">
            {/* 支払履歴のPERSONAL以外のときのみ */}
            {_w_!.current_contracted_plan.plan.name != 'personal' && (
              <Link className="btn bg-gradient-secondary me-2" to={`/w/${_w_!.identifier}/setting/workspace_payments`}>
                支払履歴
              </Link>
            )}
            <Link to={`/w/${_w_!.identifier}/setting/edit_next_plan`} className="btn bg-gradient-primary btn-icon">
              <i className="fas fa-edit" aria-hidden="true"></i>プラン変更
            </Link>
          </div>
        )}
      </div>
      <div className="card-body pt-0 row">
        <div className="col-12">
          <div className="form-group">
            <label>現在のプラン</label>
            <p className="form-text text-muted text-sm ms-1">{_w_!.current_contracted_plan.plan.label}</p>
          </div>
          <div className="form-group">
            <label>今月の最大利用ユーザ数</label>
            <p className="form-text text-muted text-sm ms-1">{_w_!.current_monthly_active_user.max_count}</p>
          </div>
          {/* 下記情報の表示はPERSONAL以外のときのみ */}
          {_w_!.current_contracted_plan.plan.name != 'personal' && <PlanInfo />}
        </div>
      </div>
    </div>
  );
};

const PlanInfo = () => {
  const { _w_, me } = useCurrentWorkspace();
  const { data: paymentInfo } = usePaymentInfo({ identifier: _w_!.identifier });

  const { data } = useWorkspacePayments({ identifier: _w_!.identifier, page: 1, per: 100 });

  if (paymentInfo == null) return <></>;

  return (
    <>
      <div className="form-group">
        <label>現在の契約期間</label>
        <p className="form-text text-muted text-sm ms-1">
          {moment(_w_!.current_contracted_plan.term_from).format('YYYY/MM/DD')} -{' '}
          {moment(_w_!.current_contracted_plan.term_to).format('YYYY/MM/DD')}
        </p>
      </div>
      <div className="form-group">
        <label>次回更新後のプラン （自動更新されます）</label>
        <p className="form-text text-muted text-sm ms-1">{_w_!.next_plan.label}</p>
      </div>
      <div className="form-group">
        <label>契約済ユーザ数</label>
        <p className="form-text text-muted text-sm ms-1">{_w_!.current_contracted_plan.contract_user_count}</p>
      </div>
      <div className="form-group">
        <label>お支払い方法</label>
        <div className="table-responsive">
          <table className="table align-items-center">
            <thead>
              <tr>
                <th
                  className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                  style={{ width: '55px' }}
                >
                  カードブランド
                </th>
                <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">
                  カード有効期限
                </th>
                <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">
                  カード番号（下4桁）
                </th>
                <th className="text-secondary opacity-7" style={{ width: '55px' }}></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-secondary text-xs font-weight-bold text-wrap">{paymentInfo.brand}</td>
                <td className="text-secondary text-xs font-weight-bold text-wrap">
                  {moment(new Date(paymentInfo.exp_year, paymentInfo.exp_month - 1)).format('MM/YY')}
                </td>
                <td className="text-secondary text-xs text-wrap">*** {paymentInfo.last4}</td>
                <td>
                  {me!.admin && (
                    <Link
                      className="btn btn-icon-only btn-outline-success"
                      to={`/w/${_w_!.identifier}/setting/edit_payment_method`}
                    >
                      <i className="fas fa-edit text-success text-sm" aria-hidden="true"></i>
                    </Link>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
